import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../../environments/environment';

import Response = ZoningAPI.Response;

import { BaseEntityService } from '../../../shared/services';
import { AttachmentLink, AttachmentLinkFactory } from 'src/app/shared';

const API_ENDPOINT = environment.ZONAR_API_URL + '/attachments';

@Injectable({
    providedIn: 'root'
})
export class AttachmentLinkService extends BaseEntityService<AttachmentLink> {
    constructor(private readonly http: HttpClient) {
        super(AttachmentLinkFactory);
    }

    deleteAttachmentLink(attachmentLinkId: number) {
        if (!Number.isInteger(attachmentLinkId)) {
            return;
        }

        return this.http.delete<Response>(`${API_ENDPOINT}/${attachmentLinkId}`);
    }
}
